<script>
import checkPermission from "@/utils/permission";

import { mapGetters } from "vuex";

import { getDicyType } from "@/api/dict";
import { getList, deleteRefuelApply, applySkipCheck } from "@/api/vehicle";

import { parseTime } from "@/utils";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import EditApply from "./EditApply.vue";

import { showPhoneAlarm } from "@/global/function.js";

export default {
  components: { Header, Footer, EditApply },
  data() {
    const listQuery = {
      limit: 10,
      page: 1,
      data: {
        checkStatus: "0",
        checkStatusName: "待审核",
        checkRefuel: undefined,
        checkRefuelName: "全部",
      },
    };

    const table = {
      listLoading: false,
      fullWidth: document.documentElement.clientWidth,
      key: 0,
      total: 0,
      data: [],
    };

    return {
      listQuery,
      showStatusPicker: false,
      showRefuelPicker: false,
      showEditPop: false,
      isUpdate: false,
      updateValue: {},
      refuelOption: {
        min: 0,
        max: 0,
      },
      refuelTypeList: [],
      refuelStatusList: [],
      statusList: [],
      refuelList: [],
      refuelCheckList: [],
      table,
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
    }),
  },
  created() {
    this.getRefuelType();
    this.getRefuelConfig();
    this.getRefuelStatus();
    this.getRefuelCheck();
    this.getListData();
  },
  methods: {
    checkPermission,
    clickLeft() {
      this.$router.go(-1);
    },
    pickerDict(dictlist) {
      return dictlist.map((dict) => ({
        name: dict.label,
        value: dict.code,
      }));
    },
    getValue(list, value) {
      return list.find((dict) => dict.value === value) || {};
    },
    onStatusChoose(status) {
      const { value, name } = status;
      this.listQuery.data.checkStatus = value;
      this.listQuery.data.checkStatusName = name;
      this.showStatusPicker = false;
    },
    onRefuelChoose(refuel) {
      const { value, name } = refuel;
      this.listQuery.data.checkRefuel = value;
      this.listQuery.data.checkRefuelName = name;
      this.showRefuelPicker = false;
    },
    getStatus: function (value) {
      if (value === undefined) return "";
      return this.statusList.find((item) => +item.value === +value)?.name;
    },
    getRefuel: function (value) {
      if (value === undefined) return "";
      return this.refuelList.find((item) => +item.value === +value)?.name;
    },
    handleTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleCreateApply() {
      this.showEditPop = true;
    },
    handleEditApply(value) {
      this.showEditPop = true;
      this.isUpdate = true;
      this.updateValue = value;
    },
    onFormClose() {
      this.isUpdate = false;
      this.updateValue = {};
    },
    onEditSuccess() {
      this.showEditPop = false;
      this.getListData();
    },
    formatStamp(timestamp) {
      if (typeof timestamp === "number")
        return parseTime(timestamp, "{y}-{m}-{d}  {h}:{i}:{s}");
      else return timestamp;
    },
    getRefuelType() {
      const that = this;
      getDicyType({ type: "refueltype" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            if (Array.isArray(data.data) && data.data.length) {
              that.refuelTypeList = data.data[0].dictDataList;
            }
          }
        })
        .catch(() => false);
    },
    getRefuelCheck() {
      const that = this;
      getDicyType({ type: "refuelcheck" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            if (Array.isArray(data.data) && data.data.length) {
              const list = [{ name: "全部", value: undefined }];
              list.push(
                ...data.data[0].dictDataList.map((dict) => ({
                  name: dict.label,
                  value: dict.value,
                }))
              );
              that.refuelList = list;
            }
          }
        })
        .catch(() => false);
    },
    getRefuelStatus() {
      const that = this;
      getDicyType({ type: "refuelstatus" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            if (Array.isArray(data.data) && data.data.length) {
              const list = [{ name: "全部", value: undefined }];
              list.push(
                ...data.data[0].dictDataList.map((dict) => ({
                  name: dict.label,
                  value: dict.value,
                }))
              );
              that.statusList = list;
            }
          }
        })
        .catch(() => false);
    },
    getRefuelConfig() {
      const that = this;
      getDicyType({ type: "refueloption" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            if (Array.isArray(data.data) && data.data.length) {
              const list = data.data[0].dictDataList || [];
              const min =
                list.find((d) => d.code === "minrefuelnum")?.value || 0;
              const max =
                list.find((d) => d.code === "maxrefuelnum")?.value || 0;
              that.refuelOption = { max, min };
              that.form.data.applyRefuelCap = max + "";
            }
          }
        })
        .catch(() => false);
    },
    async skipCheck(id) {
      const payload = {
        id,
        isSkipVfVerify: true,
      };
      const response = await applySkipCheck(payload).catch(() => false);
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            data.code,
            "跳过识别验证",
            data.message
          )
        ) {
          this.getListData();
        }
      }
    },
    async handleDelete({ id }) {
      if (confirm) {
        const response = await deleteRefuelApply([id]).catch(() => false);
        if (response) {
          const { data } = response;
          if (
            showPhoneAlarm(
              true,
              "toast",
              null,
              2000,
              data.code,
              "删除加油申请",
              data.message
            )
          ) {
            this.getListData();
          }
        }
      }
    },
    async getListData() {
      const payload = {
        page: {
          current: this.listQuery.page,
          size: this.listQuery.limit,
        },
        where: {
          "eq_apply.checkStatus": this.listQuery.data.checkStatus || undefined,
          "eq_apply.refuelStatus": this.listQuery.data.checkRefuel || undefined,
          "eq_apply.applyUserId": this.userid,
          "desc_apply.createTime": "1",
        },
      };
      const response = await getList(payload).catch(() => false);
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            false,
            "toast",
            null,
            2000,
            data.code,
            null,
            data.message
          )
        ) {
          this.table.total = data.page.total;
          this.table.data = data.page.records;
        }
      }
    },
  },
};
</script>

<template>
  <div style="background: white">
    <Header
      :show="true"
      title="加油申请"
      left="prepage"
      :click-left="clickLeft"
    />
    <div style="padding-bottom: 8vh">
      <!-- 顶部搜索相关 Cell -->
      <div>
        <van-cell
          :value="listQuery.data.checkStatusName"
          is-link
          @click="showStatusPicker = true"
        >
          <template #title>
            <span style="font-size: 2vh">审核状态</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="showStatusPicker"
          :actions="refuelList"
          cancel-text="取消"
          description="请选择查询的审核状态"
          @select="onStatusChoose"
        />
        <van-cell
          :value="listQuery.data.checkRefuelName"
          is-link
          @click="showRefuelPicker = true"
        >
          <template #title>
            <span style="font-size: 2vh">加油状态</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="showRefuelPicker"
          :actions="statusList"
          cancel-text="取消"
          description="请选择查询的加油状态"
          @select="onRefuelChoose"
        />
        <div style="margin: 16px">
          <van-button
            v-if="checkPermission([421])"
            round
            block
            type="info"
            @click="getListData"
          >
            查询
          </van-button>
          <van-button
            round
            block
            v-if="checkPermission([422])"
            type="primary"
            style="margin-top: 10px"
            @click="handleCreateApply"
          >
            新增加油申请
          </van-button>
        </div>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              :show-message="false"
              style="padding: 0 20px"
              class="tableExpressInfo"
            >
              <el-form-item label="车辆名称">
                <span>{{ row.vehicleName }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.vehicleNo }}</span>
              </el-form-item>
              <el-form-item label="加油类型">
                <span>{{
                  getValue(pickerDict(refuelTypeList), row.refuelTypeCode)
                    .name || ""
                }}</span>
              </el-form-item>
              <el-form-item label="申请加油量">
                <span>{{ row.applyRefuelCap }}</span>
              </el-form-item>
              <el-form-item label="实际加油量">
                <span>{{ row.actualRefuelCap }}</span>
              </el-form-item>
              <el-form-item label="审核时间">
                <span>{{ formatStamp(row.checkTime) }}</span>
              </el-form-item>
              <el-form-item label="加油时间">
                <span>{{ formatStamp(row.refuelTime) }}</span>
              </el-form-item>
              <div v-if="row.refuelStatus === 0">
                <van-row v-if="row.checkStatus === 0" gutter="16">
                  <van-col>
                    <van-button
                      v-if="checkPermission([423])"
                      type="primary"
                      size="small"
                      @click="handleEditApply(row)"
                    >
                      修改申请
                    </van-button>
                  </van-col>
                  <van-col>
                    <el-button
                      v-if="checkPermission([424])"
                      type="danger"
                      size="mini"
                      @click="handleDelete(row)"
                    >
                      删除申请
                    </el-button>
                  </van-col>
                </van-row>
                <van-row v-else-if="row.isSkipVfVerify === false" gutter="16">
                  <van-col>
                    <el-button
                      v-if="checkPermission([426])"
                      type="warning"
                      size="mini"
                      @click="skipCheck(row.id)"
                    >
                      申请跳过验证
                    </el-button>
                  </van-col>
                </van-row>
              </div>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          align="center"
          type="index"
          width="50px"
        />
        <el-table-column
          label="申请加油量"
          prop="applyRefuelCap"
          align="center"
          min-width="80"
          show-overflow-tooltip
        />
        <el-table-column
          label="审核状态"
          prop="checkStatus"
          align="center"
          width="90"
        >
          <template slot-scope="{ row }">
            <el-tag v-if="row.checkStatus === 0" type="warning">
              {{ getRefuel(+row.checkStatus) }}
            </el-tag>
            <el-tag v-if="row.checkStatus === 1" type="primary">
              {{ getRefuel(+row.checkStatus) }}
            </el-tag>
            <el-tag v-if="row.checkStatus === -1" type="danger">
              {{ getRefuel(+row.checkStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="加油状态"
          prop="refuelStatus"
          align="center"
          width="90"
        >
          <template slot-scope="{ row }">
            <el-tag v-if="row.refuelStatus === 0" type="info">
              {{ getStatus(+row.refuelStatus) }}
            </el-tag>
            <el-tag v-if="row.refuelStatus === 1" type="primary">
              {{ getStatus(+row.refuelStatus) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="getListData"
      />
    </div>
    <EditApply
      :visible.sync="showEditPop"
      :is-update="isUpdate"
      :default-value="updateValue"
      :refuel-option="refuelOption"
      :refuel-type-list="refuelTypeList"
      @closed="onFormClose"
      @success="onEditSuccess"
    />
    <Footer value="service" />
  </div>
</template>

<style scoped>
.tableExpressInfo .el-form-item {
  margin-bottom: 0 !important;
}
</style>